import type { ThreadStatusState } from '@dev-streetbeat/chat-ui'

import styles from './ChatStatusIndicator.module.scss'

const LABELS: Record<ThreadStatusState, string> = {
  working: 'In elaborazione',
  input_required: 'In attesa di risposta',
  done: 'Completato',
}

/**
 * Per-thread sidebar status visual, passed to chat-ui's `ThreadListPanel`
 * `threadStatus.renderIndicator`. The backend `attention` signal is the single
 * source of truth (chat-ui reads it, suppresses it for the open thread, and
 * polls the list); this component only draws it. Visuals follow the credem
 * design: a rotated block-assembly loader (working), a circle-help glyph
 * (input_required), and a small green dot (done).
 */
export function ChatStatusIndicator({ state }: { state: ThreadStatusState }) {
  return (
    <span
      className={styles.indicator}
      data-state={state}
      role="img"
      aria-label={LABELS[state]}
      title={LABELS[state]}
    >
      {state === 'working' && (
        <span className={styles.blocks}>
          {Array.from({ length: 6 }, (_, i) => (
            <i key={i} />
          ))}
        </span>
      )}
      {state === 'input_required' && (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
      )}
    </span>
  )
}
